import { InstrumentType } from '../constants/instruments'
import { Order } from '../constants/order'
import { Position } from '../constants/position'
import { ParsedOption, parseInstrumentName } from './instruments'

export const sortPositionsOrOpenOrders = <T extends Order | Position>(
  openOrderOrPositions: T[]
): T[] => {
  const sortableOpenOrderOrPositions = openOrderOrPositions.map((p) => ({
    openOrderOrPosition: p,
    instrument: parseInstrumentName(p.instrument_name),
  }))
  // Sort perps by size (descending)
  const perps = sortableOpenOrderOrPositions
    .filter((p) => p.instrument?.type === InstrumentType.Perps)
    .sort((a, b) => +b.openOrderOrPosition.amount - +a.openOrderOrPosition.amount)
    .map((p) => p.openOrderOrPosition)
  // Sort options by expiry (ascending) => strike (ascending) -> calls over puts
  const options = sortableOpenOrderOrPositions
    .filter((p) => p.instrument?.type === InstrumentType.Options)
    .sort(({ instrument: _a }, { instrument: _b }) => {
      const a = _a as ParsedOption
      const b = _b as ParsedOption
      if (a.expiry.getTime() === b.expiry.getTime()) {
        if (a.strikePrice === b.strikePrice) {
          return a.isCall ? -1 : 1
        }
        return a.strikePrice && b.strikePrice ? +a.strikePrice - +b.strikePrice : 0
      }
      return a.expiry && b.expiry ? a.expiry.getTime() - b.expiry.getTime() : 0
    })
    .map((p) => p.openOrderOrPosition)

  const spots = sortableOpenOrderOrPositions
    .filter((p) => p.instrument?.type === InstrumentType.Spot)
    .map((p) => p.openOrderOrPosition)

  return [...perps, ...options, ...spots]
}
